import { API_ENDPOINTS } from '@/utils/constants/end-points';

import apiClient from '../api-client';

export const fetchTemplatesList = async ({
  page,
  limit,
  search,
  sortDirection,
  sortColumn,
  isExport,
  categoryId,
  typeId,
  statusId,
}: {
  page?: number;
  limit?: number;
  search: string;
  sortDirection: 'asc' | 'desc';
  sortColumn: string;
  categoryId?: number;
  typeId?: number;
  isExport?: boolean;
  statusId?: number;
}) => {
  const params: Record<string, any> = {};
  if (isExport) {
    params.isExport = true;
  } else {
    if (page !== undefined) params.offset = page;
    if (limit !== undefined) params.limit = limit;
  }
  if (search) params.searchField = search;
  if (sortColumn) params.sortBy = sortColumn;
  if (sortDirection) params.sortDir = sortDirection;
  if (categoryId) params.categoryId = categoryId;
  if (typeId) params.TemplateTypeId = typeId;
  if (statusId) params.StatusLookupId = statusId;

  const queryString = new URLSearchParams(params).toString();

  const res = await apiClient.get(`${API_ENDPOINTS?.TEMPLATE}?${queryString}`);
  return res?.data?.data;
};

export const fetchTemplateTypesList = async () => {
  const res = await apiClient.get(`${API_ENDPOINTS?.TEMPLATE}/types`);
  return res?.data?.data;
};

export const fetchCategoryList = async () => {
  const res = await apiClient.get(`${API_ENDPOINTS?.TEMPLATE}/categories`);
  return res?.data?.data;
};

export const deleteTemplate = async (templateId: string | number) => {
  const res = await apiClient.delete(
    `${API_ENDPOINTS?.TEMPLATE}/${templateId}`
  );
  return res?.data;
};

export const fetchCategoryFieldsById = async (categoryId: number) => {
  const res = await apiClient.get(
    `${API_ENDPOINTS?.TEMPLATE}/categories/${categoryId}/fields`
  );
  return res?.data?.data;
};

export const createTemplate = async (payload: {
  templateName: string;
  categoryId: number | null;
  subject: string;
  bodyContent: string;
  statusLookupId?: number;
  isDraft?: boolean;
  selectedFields?: any[];
}) => {
  payload.statusLookupId = payload.statusLookupId ?? 1; // Default to Active status
  payload.isDraft = payload.isDraft ?? false; // Default to not a draft
  payload.selectedFields = payload.selectedFields ?? []; // Default to empty array if not provided

  const res = await apiClient.post(`${API_ENDPOINTS?.TEMPLATE}`, payload);
  return res?.data;
};

export const fetchTemplateById = async (templateId: number) => {
  const res = await apiClient.get(`${API_ENDPOINTS?.TEMPLATE}/${templateId}`);
  return res?.data?.data;
};

export const updateTemplate = async (
  templateId: string | number,
  payload: {
    templateName: string;
    categoryId: number | null;
    subject: string;
    bodyContent: string;
    statusLookupId?: number;
    isDraft?: boolean;
    selectedFields?: any[];
  }
) => {
  payload.statusLookupId = payload.statusLookupId ?? 1; // Default to Active status
  payload.isDraft = payload.isDraft ?? false; // Default to not a draft
  payload.selectedFields = payload.selectedFields ?? []; // Default to empty array if not provided

  const res = await apiClient.put(
    `${API_ENDPOINTS?.TEMPLATE}/${templateId}`,
    payload
  );
  return res?.data;
};

export const updateTemplateStatus = async (
  templateId: string | number,
  payload: any
) => {
  const res = await apiClient.put(
    `${API_ENDPOINTS?.TEMPLATE}/status/${templateId}`,
    payload
  );
  return res?.data;
};

export const fetchTemplateApprovalList = async (params: {
  offset?: number;
  limit?: number;
  search?: string;
  workflowStatusId?: number | string | (number | string)[];
  sortBy?: string;
  sortDir?: 'asc' | 'desc';
  isExport?: boolean;
}) => {
  const { offset, limit, search, workflowStatusId, sortBy, sortDir, isExport } =
    params;
  const queryParams: Record<string, any> = {};
  if (offset !== undefined) queryParams.offset = offset;
  if (limit !== undefined) queryParams.limit = limit;
  if (search) queryParams.searchField = search;
  if (workflowStatusId) queryParams.workflowStatusId = workflowStatusId;
  if (sortBy) queryParams.sortBy = sortBy;
  if (sortDir) queryParams.sortDir = sortDir;
  if (isExport) queryParams.isExport = isExport;

  const queryString = new URLSearchParams(queryParams).toString();
  const url = `${API_ENDPOINTS?.MAINTENANCE}/templates?${queryString}`;

  const res = await apiClient.get(url);
  return res?.data?.data;
};

export const templateDetailsForApproval = async (txnId: string) => {
  const res = await apiClient.get(`${API_ENDPOINTS?.MAINTENANCE}/${txnId}`);
  return res?.data?.data;
};

export const approveTemplate = async (payload: {
  txnId: string;
  action: string;
  remarks?: string;
}) => {
  const res = await apiClient.post(
    `${API_ENDPOINTS?.TEMPLATE}/checker-action`,
    payload
  );
  return res?.data;
};

export const reviseTemplate = async (
  payload: {
    templateName: string;
    categoryId: number | null;
    subject: string;
    bodyContent: string;
    statusLookupId?: number;
    isDraft?: boolean;
    selectedFields?: any[];
  },
  txnId: string
) => {
  payload.statusLookupId = payload.statusLookupId ?? 1; // Default to Active status
  payload.isDraft = payload.isDraft ?? false; // Default to not a draft
  payload.selectedFields = payload.selectedFields ?? []; // Default to empty array if not provided

  const res = await apiClient.put(
    `${API_ENDPOINTS?.TEMPLATE}/revision/${txnId}`,
    payload
  );
  return res?.data;
};

export const sendPreviewEmail = async (templateId: string | number) => {
  const res = await apiClient.post(
    `${API_ENDPOINTS?.TEMPLATE}/${templateId}/send-email`
  );
  return res?.data;
};
